import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { getTeamPage } from '../../api/workEnvironmentQueries';

export const TeamPageQueryKey = 'WORK_ENVIRONMENT_TEAM_PAGE';

export const useTeamPageQuery = (uuid: string | undefined, language: string) =>
  useQuery({
    queryKey: [TeamPageQueryKey, uuid, language],
    queryFn: () => getTeamPage(uuid!, language),
    enabled: Boolean(uuid),
    placeholderData: keepPreviousData,
    retry: false,
  });
